function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M328,432h16c4.4,0,8-3.6,8-8V152c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v272C320,428.4,323.6,432,328,432z M168,432h16 c4.4,0,8-3.6,8-8V152c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v272C160,428.4,163.6,432,168,432z M472,64H368l-33.6-44.8 C325.3,7.1,311.1,0,296,0h-80c-15.1,0-29.3,7.1-38.4,19.2L144,64H40c-4.4,0-8,3.6-8,8v16c0,4.4,3.6,8,8,8h24v368 c0,26.5,21.5,48,48,48l0,0h288c26.5,0,48-21.5,48-48l0,0V96h24c4.4,0,8-3.6,8-8V72C480,67.6,476.4,64,472,64z M203.2,38.4 c3-4,7.8-6.4,12.8-6.4h80c5,0,9.8,2.4,12.8,6.4L328,64H184L203.2,38.4z M416,464c0,8.8-7.2,16-16,16H112c-8.8,0-16-7.2-16-16V96h320 V464z M248,432h16c4.4,0,8-3.6,8-8V152c0-4.4-3.6-8-8-8h-16c-4.4,0-8,3.6-8,8v272C240,428.4,243.6,432,248,432z"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0e0f4849.svg";
export { ForwardRef as ReactComponent };